import React from "react";
import { Outlet } from "react-router-dom";
import './settings.scss';

const SettingsOutlet = () => {
    return (
        <div className="settings">
            <Outlet />
        </div>
    )
}

export default SettingsOutlet;